var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-badge",
    {
      attrs: {
        color: _vm.badgeColor,
        overlap: "",
        value: _vm.badgeNumber !== 0
      },
      scopedSlots: _vm._u([
        {
          key: "badge",
          fn: function() {
            return [
              _c("span", { staticClass: "opposite--text" }, [
                _vm._v(_vm._s(_vm.badgeNumber))
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "", disabled: !_vm.tooltipText },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _c(
                    "v-icon",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { color: _vm.iconColor },
                          on: {
                            click: function($event) {
                              return _vm.$emit("click", $event)
                            }
                          }
                        },
                        "v-icon",
                        _vm.$attrs,
                        false
                      ),
                      on
                    ),
                    [_vm._v("\n        " + _vm._s(_vm.icon) + "\n      ")]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.tooltipText))]),
          _vm._v(" "),
          _vm._l(_vm.tooltipArray, function(item, index) {
            return _c("div", { key: index }, [
              _vm._v("\n      " + _vm._s(item) + "\n    ")
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }